import { TireSeason } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { NoddiEmptyContent } from 'noddi-ui-web';
import { TireMeasurementCard, type TireMeasurementTranslations } from './TireMeasurementCard';
import {
  treadDepthThresholdsFromLatest,
  wheelSetMeasurementsFromTreadDepthLatest
} from './wheelSetCarWheelMeasurements';

interface LatestTireMeasurementsProps {
  carId: number;
  tireSeason: TireSeason;
  translations?: TireMeasurementTranslations;
  collapsible?: boolean;
  surface?: 'card' | 'plain';
}

export const LatestTireMeasurements = ({
  carId,
  translations,
  tireSeason,
  collapsible,
  surface
}: LatestTireMeasurementsProps) => {
  const {
    data: tireMeasurements,
    isPending: isTireMeasurementsPending,
    error: tireMeasurementsError
  } = noddiAsync.useGet({
    type: URLKeys.getLatestCarWheelMeasurements,
    input: { carId }
  });

  if (isTireMeasurementsPending) {
    return <div className='flex h-20 w-full animate-pulse rounded-lg bg-darkPurple40' />;
  }

  const measurements = tireSeason ? wheelSetMeasurementsFromTreadDepthLatest(tireMeasurements, tireSeason) : null;

  if (tireMeasurementsError || !measurements) {
    return (
      <NoddiEmptyContent
        size='small'
        title='No tire measurements'
        message='No tread depth measurements are recorded for this season.'
      />
    );
  }

  return (
    <TireMeasurementCard
      tireSeason={tireSeason}
      thresholds={treadDepthThresholdsFromLatest(tireMeasurements, tireSeason)}
      translations={translations}
      measurements={measurements}
      collapsible={collapsible}
      surface={surface}
    />
  );
};
